import './navbar.css';
import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Button, Collapse, Container, Dropdown, Modal, Nav, NavDropdown, Navbar } from 'react-bootstrap';
import { BASE_ROUTE } from '../config';
import { NavLink, useLocation } from 'react-router-dom';
import { BsBell, BsChevronDown } from "react-icons/bs";
import { http_request } from '../libs/connection';
import { getUserInfo, auth, createTimeString } from '../libs/lib';

function NavBar(props) {
  const ROWS = 100;
  const user_info = getUserInfo();
  const location = useLocation();
  const { pathname } = location;
  const { is_authenticated } = props;
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [is_loading, setLoadingStatus] = useState(false);
  const [dialog_show, showDialog] = useState(false);
  const [nav_expand, expandNav] = useState(false);
  const dialog_ref = useRef(false);

  /**
   * 规则:
   *  换页时刷新通知清单
   *  每闲置1分钟刷新通知清单
   *  通知至少一则未读时显示未读红点
   *  通知只抓未读，因为如果所有通知都显示的话，假设有一万笔，其中倒数第二笔未读，要消到那一笔要 MORE 超级多次
   *  展开通知时已读该通知
   *  目前不可以全部已读，因为全部以读要所有通知全抓才有 id 可以送 read
   */

  useEffect(()=>{
    initTimer();
  }, []);

  useEffect(()=>{
    expandNav(false);
  }, [pathname]);

  useEffect(()=>{
    loadNotifications(1);
  }, [pathname, page]);

  useEffect(()=>{
    dialog_ref.current = dialog_show;
  }, [dialog_show]);

  function initTimer(){
    if(window.timer) clearInterval(window.timer);
    window.timer = setInterval(function(){ 
      if(!dialog_ref.current) loadNotifications(1);
    }, 180000);
  }

  function loadNotifications(p){
    if(is_loading) return;
    if(!user_info.id) return;
    let params = {
      page: p || page,
      rows: ROWS,
    };
    setLoadingStatus(true);
    http_request('/notice/list', 'POST', params).then(res=>{
      setLoadingStatus(false);
      if(res.success){
        let list = res.data.notices || [];
        setNotifications(p ? list : notifications.concat(list));
        setTotal(res.data.total || 0);
      }
    })
  }
  function more(){
    setPage(page + 1);
  }
  function showNotificationDialog(){ //打开通知列表
    setPage(1);
    readAll();
    showDialog(true);
  }
  function showNoticeBadge(){
    return notifications.filter(n=>n.is_read == 0).length !== 0;
  }

  function readAll(){//全部已读
    let params = {
      time: createTimeString('y-m-d h:i:s')
    };
    http_request('/notice/read', 'POST', params);
  }
  function toggleNotification(n){//展开通知
    let new_list = JSON.parse(JSON.stringify(notifications));
    new_list[n].open = !new_list[n].open;
    setNotifications(new_list);
  }
  function cloaseDialog(){
    showDialog(false);
    loadNotifications(1);
  }
  return (
    <Fragment>
      <Modal
        show={dialog_show}
        onHide={()=>{ 
          cloaseDialog();
        }}
        centered
        id="notification-dialog"
      >
        <Modal.Header className='d-flex align-items-center justify-content-start'>
            <span className='fw-bold'>通知</span>
        </Modal.Header>
        <Modal.Body className='p-0'>
          {
            notifications.length ? <div id="notification-container">
              {
                notifications.map((notification, n)=><div key={n} className={`p-3 border-bottom ${notification.is_read == 1 ? 'is-read' : ''}`} onClick={()=>{
                    toggleNotification(n);
                }}>
                  <div className="d-flex align-items-center justify-content-between">
                    <span>{ (notification.message || '').substr(0, 24) }...</span>
                    <span><BsChevronDown /></span>
                  </div>
                  <Collapse in={notification.open}>
                    <div className='pt-2 text-secondary' style={{ fontSize: 13 }}>{ notification.message }</div>
                  </Collapse>
                </div>)
              }
              <div className='p-3 d-flex align-items-center justify-content-center'>
                {
                  (page >= (Math.ceil(total / ROWS))) ? <span className='px-4 py-3'>无更多资料</span> : <Button 
                    variant='secondary' 
                    size='sm' 
                    className='px-4' 
                    onClick={()=>{ more(); }}
                  >MORE</Button>
                }
              </div>
            </div> : <NoNotification />
          }
        </Modal.Body>
        <Modal.Footer className='d-flex align-items-center justify-content-end'>
          <Button variant='danger' size='sm' className='px-3' onClick={()=>{ cloaseDialog(); }}>关闭</Button>
        </Modal.Footer>
      </Modal>
      <Navbar id="nav-bar" expand="lg" className="bg-body-tertiary" onToggle={()=>{ expandNav(!nav_expand); }} expanded={nav_expand}>
        <Container>
          <Navbar.Brand href={`${BASE_ROUTE}/`}>厂商ERP</Navbar.Brand>
          <Navbar.Toggle 
            aria-controls="basic-navbar-nav"
            id="navbar-toggler"
            children={
              <span>
                <span className="navbar-toggler-icon"></span>
                <span className={`${!showNoticeBadge() ? 'd-none' : ''} red-badge badge-sm`}></span>
              </span>}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <NavDropdown
                title="採购"
              >
                { auth("global.purchaseOrder") && <Dropdown.Item as={NavLink} to={`${BASE_ROUTE}/purchase/list`}>採购单</Dropdown.Item> }
                { auth("global.purchaseOrder") && <Dropdown.Item as={NavLink} to={`${BASE_ROUTE}/purchase/refund/list`}>採购退货单</Dropdown.Item> }
                { auth("global.purchaseOrder") && <Dropdown.Item as={NavLink} to={`${BASE_ROUTE}/purchase/ship/list`}>採购出货纪录</Dropdown.Item> }
                { auth("global.purchaseRejectOrder") && <Dropdown.Item as={NavLink} to={`${BASE_ROUTE}/purchase/reject/list`}>采购拒收單</Dropdown.Item> }
                { auth("global.purchaseOrder") && <Dropdown.Item as={NavLink} to={`${BASE_ROUTE}/purchase/vendor_material_shortages`}>欠料表</Dropdown.Item> }
              </NavDropdown>
              <NavDropdown
                title="外包"
              >
                { auth("global.outsourcingOrder") && <Dropdown.Item as={NavLink} to={`${BASE_ROUTE}/outsourcing/list`}>外包单</Dropdown.Item> }
                { auth("global.outsourcingReturnOrder") && <Dropdown.Item as={NavLink} to={`${BASE_ROUTE}/outsourcing/refund/list`}>外包退货单</Dropdown.Item> }
                { auth("global.outsourcingShipOrder") && <Dropdown.Item as={NavLink} to={`${BASE_ROUTE}/outsourcing/ship/list`}>外包出货纪录</Dropdown.Item> }
                { auth("global.outsourcingRejectOrder") && <Dropdown.Item as={NavLink} to={`${BASE_ROUTE}/outsourcing/reject/list`}>外包拒收單</Dropdown.Item> }
                { auth("global.outsourcingOrder") && <Dropdown.Item as={NavLink} to={`${BASE_ROUTE}/outsourcing/vendor_material_shortages`}>欠料表</Dropdown.Item> }
              </NavDropdown>
              { auth("global.invoice") && <NavLink className={'nav-link'} to={`${BASE_ROUTE}/invoice/list`}>请款单</NavLink> }
              { auth("company.user") && <NavLink className={'nav-link'} to={`${BASE_ROUTE}/provider`}>厂商使用者</NavLink> }
              <NavLink className={'nav-link'} to={`${BASE_ROUTE}/account`}>帐号</NavLink>
              <span className='d-sm-none d-block nav-link' style={{height: 40}} onClick={()=>{ showNotificationDialog(); }}>
                <span>通知</span>
                <span className={`${!showNoticeBadge() ? 'd-none' : ''} red-badge badge-sm`} style={{ top:-24, right: -32 }}></span>
              </span>
              {
                is_authenticated ? <NavLink className={'nav-link'} to={`${BASE_ROUTE}/logout`}>登出</NavLink> : <NavLink className={'nav-link'} to={`${BASE_ROUTE}/login`}>登入</NavLink>
              }
            </Nav>
            <Nav className='d-sm-block d-none'>
              <span id="bell-container" className='cursor-pointer' onClick={()=>{ showNotificationDialog(); }}>
                <BsBell size={20} color='rgb(0,0,0,.65)' />
                <span className={`${!showNoticeBadge() ? 'd-none' : ''} red-badge badge-md`}></span>
              </span>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Fragment>
  )
}

export default NavBar;

function NoNotification(){
  return <div id="no-notification">没有未读通知</div>
}